$(function () {

  // On click / touch start
  $('.scents-wrap li button').on('click touchstart', function () {

    const index = $(this).parent().index() + 1

    // Add/remove classes
    $('.subtitle-details').addClass('hidden')
    $('.scents-wrap li button').removeClass('active')
    $('.scents-copy li').removeClass('active')
    $(`.scents-wrap li:nth-child(${index}) button`).addClass('active')
    $(`.scents-copy li:nth-child(${index})`).addClass('active')
    $('.scents-wrap').addClass('subitem-active')

    // Select option
    doOptionSelected()
  })

  // If is not touch device...
  if (!(window as any).Modernizr.touchevents) {

    // On mouse enter
    $('.scents-wrap li button').on('mouseenter', function () {

      const index = $(this).parent().index() + 1

      // Add class "current" to hovered button
      $(`.scents-wrap li:nth-child(${index}) button`).addClass('current')

      // Define min-height to the container
      $(this).closest('.hah-accordion-content').css('height', 'fit-content')

      // Hide scents default copy
      $('.subtitle-details').addClass('hidden')

      // Display correct scent copy and hide the rest
      document.querySelectorAll('.scent-copy').forEach((elem) => {
        elem.querySelectorAll('li').forEach((listItemElem, elemIndex) => {
          if (elemIndex === index) {
            listItemElem.setAttribute('style', 'display: block; position: unset;')
            listItemElem.classList.add('active')
          } else {
            listItemElem.setAttribute('style', 'display: none; position: absolute;')
            listItemElem.classList.remove('active')
          }
        })
      })
    })

    // On mouse leave
    $('.scents-wrap li button').on('mouseleave', function () {

      const index = $(this).parent().index() + 1

      // Get index of active button
      const activeButton = $('.scents-wrap li button.active')
      const activeButtonIndex = activeButton.length
        ? activeButton.parent().index() + 1
        : -1

      // Remove class "current" from hovered button
      $(`.scents-wrap li:nth-child(${index}) button`).removeClass('current')

      if (!activeButton.length) { 
        // Undefine min-height in the container
        $(this).closest('.hah-accordion-content').css('min-height', '')
      }

      // Hide all scent copies with exception of the active
      document.querySelectorAll('.scent-copy').forEach((elem) => {
        elem.querySelectorAll('li').forEach((listItemElem, elemIndex) => {
          if (elemIndex === activeButtonIndex) {
            listItemElem.setAttribute('style', 'display: block; position: unset;')
            listItemElem.classList.add('active')
          } else {
            listItemElem.setAttribute('style', 'display: none; position: absolute;')
            listItemElem.classList.remove('active')
          }
        })
      })

      if (activeButtonIndex > -1) {
        // Hide scents default copy
        $('.subtitle-details').addClass('hidden')
      } else {
        // Display scents default copy
        $('.subtitle-details').removeClass('hidden')
      }
    })
  }
})

function doOptionSelected() {

  const tmpItemID = (document.getElementById('OCForm1') as HTMLFormElement).productID
  const tmpInvtID = $('ul.scent-options li button.active').data('invtid')
  const extensionGroup = $('ul.scent-options').data('extensiongroupname')
  const groundShipIDs = (document.getElementById('OCForm1') as HTMLFormElement).groundShipIDs.value.split(',')
  const prices = getInvtIDPrices(tmpInvtID)
  const addOnProductID = document.getElementById('addOnProductID') !== null
    ? (document.getElementById('addOnProductID') as HTMLInputElement).value
    : ''

  let inStockOverride = false
  let addonExtensionGroup: string

  // If there is an addon...
  if (addOnProductID) {
    addonExtensionGroup = (document.querySelector('#OCForm1') as HTMLFormElement).productIDExtensionGroups[1].value.split(';')[0]

    // If the addon has extensions...
    if (addonExtensionGroup) {

      let addonSelector: HTMLSelectElement = document.getElementById(`${addOnProductID}${addonExtensionGroup}`) as HTMLSelectElement

      // Select the addon extension
      if (addonExtensionGroup === extensionGroup) {
        addonSelector.value = $('ul.scent-options li button.active').data('extensioncode')
      } else {
        addonSelector.selectedIndex = 1
      }
    }
  }

  // If there are items to be shipped only by ground...
  if (groundShipIDs != null) {
    for (var j = 0; j < groundShipIDs.length; j++) {

      // If the select item is in the list of items to be shipped only by ground...
      if (groundShipIDs[j] == tmpItemID) {
        inStockOverride = true
        j = groundShipIDs.length
      }
    }
  }

  // Get the custom stock message
  const customStockMessage = getStockMessageAndUpdateAddToCartButtonVisibility(tmpInvtID, 0, inStockOverride)

  // If there is a custom "out of stock" message defined...
  if (customStockMessage != '') {

    // Use the custom "out of stock" message
    document.getElementById(`main-item-out-of-stock-message`).innerHTML = customStockMessage

    // Try to define the subscription item "out of stock" message
    try {
      document.getElementById(`subscription-item-out-of-stock-message`).innerHTML = customStockMessage
    } catch (error) { }
  }

  // If there isn't a custom "out of stock" message defined...
  else {

    // Use the default "out of stock" message
    // document.getElementById('SPANstock0').innerHTML = (document.getElementById('OCForm1') as HTMLFormElement).itemStockMsg.value
    document.getElementById(`main-item-out-of-stock-message`).innerHTML = (document.getElementById('OCForm1') as HTMLFormElement).itemStockMsg.value

    // Try to define the subscription item "out of stock" message
    try {
      // document.getElementById('SPANstock1').innerHTML = (document.getElementById('OCForm1') as HTMLFormElement).itemStockMsg.value
      document.getElementById(`subscription-item-out-of-stock-message`).innerHTML = (document.getElementById('OCForm1') as HTMLFormElement).itemStockMsg.value
    } catch (error) { }
  }

  // If there is a promo happening...
  if (prices.basePrice != 0 && prices.listPrice != 0 && prices.basePrice != prices.listPrice) {

    // Update HTML with screen reader utilities
    document.getElementById('main-item-price').innerHTML = '<span aria-hidden="false" class="only-readers">Regular price</span>' +
      '<strike>' + CommonUtils.toUSD(prices.listPrice) + '</strike>' +
      '<span aria-hidden="false" class="only-readers">Sale price</span>' +
      '<span class="salePrice">' + CommonUtils.toUSD(prices.basePrice) + '</span>'
  }

  // If there isn't a promo happening...
  else {

    // Update the HTML with the base price
    if (prices.basePrice != 0) {
      document.getElementById('main-item-price').innerHTML = CommonUtils.toUSD(prices.basePrice)
    }

    // Update the HTML with the price range
    else {
      document.getElementById('main-item-price').innerHTML = (document.getElementById('OCForm1') as HTMLFormElement).priceRange.value
    }
  }
}

function getInvtIDPrices(tmpInvtID: any) {

  const returnValue: {
    basePrice: number
    listPrice: number
  } = {
    basePrice: 0,
    listPrice: 0
  }

  returnValue.basePrice = parseFloat(itemPrices[tmpInvtID])
  returnValue.basePrice = Number(returnValue.basePrice.toFixed(2))

  if ((returnValue.basePrice == 0) || (isNaN(returnValue.basePrice))) {
    returnValue.basePrice = 0
  }

  returnValue.listPrice = parseFloat(itemListPrices[tmpInvtID])
  returnValue.listPrice = Number(returnValue.listPrice.toFixed(2))

  if ((returnValue.listPrice == 0) || (isNaN(returnValue.listPrice))) {
    returnValue.listPrice = 0
  }

  return returnValue
}

function getStockMessageAndUpdateAddToCartButtonVisibility(stockInvtID: string, elementIndex: number, inStockOverride: any) {

  let returnValue = '<strong>Coming Soon</strong>'

  try {

    const stockMessageValues = itemStockLevel[stockInvtID].split('|')
    const stkItem = parseInt(stockMessageValues[0])
    const qtyAvail = parseInt(stockMessageValues[1])
    const reOrdQty = parseInt(stockMessageValues[2])
    const reOrdQtyOverride = parseInt(stockMessageValues[3])
    const customInStockMessage = stockMessageValues[4]

    // If it's not a stock item or there is an override...
    if (stkItem === 0 || inStockOverride) {

      // Dropship items are always in stock
      returnValue = (customInStockMessage === '') ? defaultInStockMessage : customInStockMessage

      // Show "Add to cart" button
      showHideProductSetAddToCartButton(elementIndex, 'in')

      // Try to show "Subscribe" button
      try {
        showHideProductSetAddToCartButton(elementIndex + 1, 'in')
      } catch (error) { }
    } else {

      // If the item is out of stock...
      if (qtyAvail <= 0) {

        returnValue = (customInStockMessage === '')
          ? returnValue
          : customInStockMessage

        // Hide "Add to cart" button
        showHideProductSetAddToCartButton(elementIndex, 'out')

        // Try to hide "Subscribe" button
        try {
          showHideProductSetAddToCartButton(elementIndex + 1, 'out')
        } catch (error) { }

      }

      // If the item is low in stock...
      else if (qtyAvail <= reOrdQtyOverride || qtyAvail <= reOrdQty) {

        returnValue = defaultLowStockMessage

        // Show "Add to cart" button
        showHideProductSetAddToCartButton(elementIndex, 'in')

        // Try to show "Subscribe" button
        try {
          showHideProductSetAddToCartButton(elementIndex + 1, 'in')
        } catch (error) { }
      }

      // If the item is in stock...
      else {

        returnValue = defaultInStockMessage

        // Show "Add to cart" button
        showHideProductSetAddToCartButton(elementIndex, 'in')

        // Try to show "Subscribe" button
        try {
          showHideProductSetAddToCartButton(elementIndex + 1, 'in')
        } catch (error) { }
      }
    }
  } catch (e) {
    console.warn(e.message)
  }

  return returnValue
}

function showHideProductSetAddToCartButton(elementIndex: number, status: 'out' | 'in') {

  // Hide
  if (status === 'out') {

    try {
      document.getElementById('SPANQty' + elementIndex).style.display = 'none'
      document.getElementById('SPANQty' + elementIndex).style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }

    try {
      (document.getElementById('OCForm1') as HTMLFormElement).quantity.style.display = 'none';
      (document.getElementById('OCForm1') as HTMLFormElement).quantity.style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById('setQuantity').style.display = 'none'
      document.getElementById('setQuantity').style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById('addition').style.display = 'none'
      document.getElementById('addition').style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }

    try {
      (document.getElementById('OCForm1') as HTMLFormElement).quantity[elementIndex].style.display = 'none';
      (document.getElementById('OCForm1') as HTMLFormElement).quantity[elementIndex].style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById('add-to-cart-button').style.display = 'none'
      document.getElementById('add-to-cart-button').style.visibility = 'hidden'
      document.getElementById('subscribe-button').style.display = 'none'
      document.getElementById('subscribe-button').style.visibility = 'hidden'
      document.getElementById('disclaimer').style.display = 'none'
      document.getElementById('disclaimer').style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById(`${elementIndex === 0 ? 'main' : 'subscription'}-item-out-of-stock-message`).style.display = ''
      document.getElementById(`${elementIndex === 0 ? 'main' : 'subscription'}-item-out-of-stock-message`).style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }
  }

  // If status !== 'out' (show)
  else {

    try {
      document.getElementById('SPANQty' + elementIndex).style.display = ''
      document.getElementById('SPANQty' + elementIndex).style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      (document.getElementById('OCForm1') as HTMLFormElement).quantity.style.display = '';
      (document.getElementById('OCForm1') as HTMLFormElement).quantity.style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById('setQuantity').style.display = ''
      document.getElementById('setQuantity').style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      (document.getElementById('OCForm1') as HTMLFormElement).qty.display = '';
      (document.getElementById('OCForm1') as HTMLFormElement).qty.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById('addition').style.display = ''
      document.getElementById('addition').style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      (document.getElementById('OCForm1') as HTMLFormElement).quantity[elementIndex].style.display = '';
      (document.getElementById('OCForm1') as HTMLFormElement).quantity[elementIndex].style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById('add-to-cart-button').style.display = ''
      document.getElementById('add-to-cart-button').style.visibility = 'visible'
      document.getElementById('subscribe-button').style.display = ''
      document.getElementById('subscribe-button').style.visibility = 'visible'
      document.getElementById('disclaimer').style.display = ''
      document.getElementById('disclaimer').style.visibility = 'visible'
    } catch (e) { console.warn(e.message) }

    try {
      document.getElementById(`${elementIndex === 0 ? 'main' : 'subscription'}-item-out-of-stock-message`).style.display = 'none'
      document.getElementById(`${elementIndex === 0 ? 'main' : 'subscription'}-item-out-of-stock-message`).style.visibility = 'hidden'
    } catch (e) { console.warn(e.message) }
  }
}
